import { useContext, useEffect, useState } from "react";
import styles from "./styles/PosTicketResult.module.css";
import NavButton from "../../../components/ui/navbutton/NavButton";
import LicencePlate from "../../../components/ui/licence_plate/LicencePlate";
import DataContext from "../../../context/DataContext";
import useCurrencySymbol from "../../../hooks/useCurrencySymbol";
// import Payment from "./Payment";
import { useTranslation } from "react-i18next";
import POSDataContext from "../../../context/POSDataContext";
import AuthContext from "../../../context/AuthContext";
import { axiosSW } from "../../../api/axiosDefaults";
import PosSearchTicket from "../../../components/ui/pos_side_ticket/PosSearchTicket";
import Spinner from "../../../components/ui/spinner/Spinner";
import PosSearchSettlement from "../../../components/ui/pos_side_settlement/PosSearchSettlement";
import { useNavigate } from "react-router-dom";
import LicensePlateDetect from "../../../components/ui/licence_plate_detect/LicencePlateDetect";

import { img1, img2, img3, img4 } from "./test1";
import ButtonPopup from "../../../components/ui/button_popup/ButtonPopup";

/**
 * Ticket panel component
 */
const PosTicketPanel = ({
    setShowTicketInfo, // {Function} - Function to set the visibility of the ticket information
    selectedInstalmentsPos,
    selectedSettlementsPos,
    setSelectedInstalmentsPos,
    handleCheckInstalment,
    handleCheckSettlement,

    clickedInstalmentPos,
    setClickedInstalmentPos,
    setCurrenInstalmentPos,
    handleClickedInstalment,
}) => {
    const { t } = useTranslation();

    const {
        connection, // {Object} - The current customer settings
        homePath, // {String} - The path to the home page
    } = useContext(DataContext);
    const {
        isProcessingPos, // {Boolean} - Indicates if the sata is processing in POS module
        isValidSearchPos, // {Boolean} - Indicates if the search is valid in POS module
        fetchTickets, // {Function} - Function to fetch tickets
        filterExpression, // {String} - The filter expression used for ticket search
        responseDataPos, // {Object} - The response data from fetching tickets in POS module
        incCount, // {Function} increment the count of the items in the cart
        handleErrorPos, // {Function} - Function to handle errors in POS module
        selectedTicketsPos,
        setSelectedTicketsPos,
        setIsAddHoverPos,
        setResultPos,
        userLogout,
    } = useContext(POSDataContext);
    const {
        user, // {Object} - The authenticated user data object
    } = useContext(AuthContext);
    const [clickedTicketPos, setClickedTicketPos] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);
    const [responseDataBuffer, setResponseDataBuffer] =
        useState(responseDataPos);

    const navigate = useNavigate();
    const currency = useCurrencySymbol(true);

    useEffect(() => {
        if (!responseDataPos) return;
        setResponseDataBuffer(responseDataPos);
    }, [responseDataPos]);

    useEffect(() => {
        setIsAddHoverPos(false);
    }, []);

    // ---------------------------------------------------------- not needed need testing
    // useEffect(() => {
    //     if (
    //         responseDataPos &&
    //         !responseDataPos?.ticket &&
    //         !responseDataPos?.relatedTickets?.length &&
    //         !responseDataPos?.settlements?.length
    //     ) {
    //         setResultPos(responseDataPos);
    //         navigate(`${homePath}/result`);
    //     }
    // }, [responseDataPos]);
    // ---------------------------------------------------------- not needed need testing

    // const forceUncheck =(ticketnumber)=>{
    //     setSelectedTicketsPos((selected) =>
    //             selected?.filter(
    //                 (ticket) => ticket?.ticketNumber === ticketnumber
    //             ).length
    //                 ? selected?.filter(
    //                     (ticket) => ticket?.ticketNumber !== ticketnumber
    //                 )
    //                 : [
    //                     ...selected

    //                 ]
    //         );
    //     };
    // }

    /**
     * Check box ticket handle
     * Add checked ticket to checked tickets array
     * @param {Event} event - The event object
     */
    const handleCheck = (event) => {
        event.stopPropagation(); // prevent bubbling on clicking
        setSelectedTicketsPos((selected) =>
            selected?.filter(
                (ticket) => ticket?.ticketNumber === event.target.name,
            ).length
                ? selected?.filter(
                      (ticket) => ticket?.ticketNumber !== event.target.name,
                  )
                : [
                      ...selected,
                      {
                          ticketNumber: event.target.name,
                          amount: event.target.value,
                          // Values taken from dataset stored in the checked ticket element
                          ticketDate: event.target.dataset.ticketdate,
                          offences: JSON.parse(event.target.dataset.offences),
                          ticketID: event.target.dataset.ticketid,
                          transactionID: event.target.dataset.transactionid,
                      },
                  ],
        );
    };

    /**
     * Ticket click handle
     * Set the clicked ticket to current ticket
     */
    const handleClickedTicket = (ticketNumber) =>
        setClickedTicketPos(ticketNumber);

    /**
     * Add selected tickets to the cart
     * Promise all is used in case of multiple tickets
     */
    const handleAddSelection = async () => {
        if (selectedTicketsPos.length) {
            setIsProcessing(true);
            setShowTicketInfo(false); // Hide the ticket info component

            const tickets = selectedTicketsPos.map((ticket) => ({
                transactionID: ticket?.transactionID,
                price: ticket?.amount,
            }));

            const payLoad = {
                uniqueIdentifier: connection?.uniqueIdentifier,
                cartID: user?.cartID,
                ticketCartItems: tickets,
            };
            try {
                const { data } = await axiosSW.post(
                    "ShoppingCart/pos/AddShoppingCartItem",
                    payLoad,
                );

                if (data?.statusOk) {
                    filterExpression && fetchTickets(filterExpression, 1); // Update the tickets
                    incCount(selectedTicketsPos.length); // increase the item count by the number of tickets added
                }
                setSelectedTicketsPos([]);
            } catch (error) {
                if (error?.request?.status === 403) {
                    setResultPos({
                        outputStatus: 101,
                    });
                    navigate(`${homePath}/result`);
                } else if (error?.request?.status === 404) {
                    userLogout();
                } else {
                    handleErrorPos(error);
                }
            } finally {
                setIsProcessing(false); // Always reset the processing state
            }
        }
        if (selectedInstalmentsPos.length) {
            setIsProcessing(true);
            setShowTicketInfo(false); // Hide the ticket info component

            const instalments = Object.values(
                selectedInstalmentsPos.reduce((acc, item) => {
                    const txId = item.instalmentTransactionID;
                    if (!acc[txId]) {
                        acc[txId] = {
                            transactionID: txId,
                            linkedInstallments: [],
                        };
                    }
                    acc[txId].linkedInstallments.push({
                        chargeID: item.instalmentId,
                        price: item.amount,
                    });
                    return acc;
                }, {}),
            );

            const payLoad = {
                uniqueIdentifier: connection?.uniqueIdentifier,
                cartID: user?.cartID,
                settlementCartItems: instalments,
            };
            try {
                const { data } = await axiosSW.post(
                    "ShoppingCart/pos/AddShoppingCartItem",
                    payLoad,
                );

                if (data?.statusOk) {
                    filterExpression && fetchTickets(filterExpression, 1); // Update the tickets
                    incCount(instalments.length); // increase the item count by the number of tickets added
                }
                setSelectedInstalmentsPos([]);
            } catch (error) {
                // -------------------------------------------- case of can not add a reserved item to the shopping cart
                if (error?.request?.status === 403) {
                    setResultPos({
                        outputStatus: 101,
                    });
                    navigate(`${homePath}/result`);
                }
                // ---------------------------------------------
                else if (error?.request?.status === 404) {
                    userLogout();
                } else {
                    handleErrorPos(error);
                }
            } finally {
                setIsProcessing(false); // Always reset the processing state
            }
        }
    };

    // const base64Image = img1;

    return (
        <aside className={`${styles.main_side_container} v-flex-container`}>
            <div
                className={`${styles.main_side_button_plate_container} flex-container`}
            >
                <div className={`${styles.main_side_button_container}`}>
                    <NavButton
                        body={t(`new search`)}
                        size={"adapt"}
                        link={homePath}
                    />
                </div>
                <div className={`${styles.main_licence_container}`}>
                    {responseDataBuffer?.ticket?.plate ||
                    responseDataBuffer?.settlements?.[0]?.plate ||
                    responseDataBuffer?.relatedTickets?.[0]?.plate ? (
                        <LicencePlate
                            // country={""}
                            // country={"D"}
                            number={
                                responseDataBuffer?.ticket?.plate
                                    ? responseDataBuffer?.ticket?.plate
                                    : responseDataBuffer?.settlements?.[0]
                                            ?.plate
                                      ? responseDataBuffer?.settlements?.[0]
                                            ?.plate
                                      : responseDataBuffer?.relatedTickets?.[0]
                                            ?.plate
                            }
                            // base64Image={img2}
                        />
                    ) : (
                        <></>
                    )}

                    {/* <LicensePlateDetect base64Image={base64Image} /> */}
                </div>
            </div>
            <section
                className={`${styles.main_side_tickets_container} v-flex-container`}
            >
                {isValidSearchPos && (isProcessing || isProcessingPos) ? (
                    // the spinner inside the ticket panel will be shown instead of the spinner on the main page
                    // when tickets are added and updated
                    <Spinner />
                ) : (
                    <>
                        <div
                            className={`${styles.main_tickets_container} v-flex-container`}
                        >
                            {responseDataBuffer?.ticket ||
                            responseDataBuffer?.relatedTickets ? (
                                <h4
                                    className={`${styles.ticket_type_label} flex-container`}
                                >
                                    {responseDataBuffer?.outputStatus === 4
                                        ? t(`searched ticket`)
                                        : t(`related tickets`)}
                                </h4>
                            ) : (
                                <></>
                            )}

                            {responseDataBuffer?.ticket ||
                            responseDataBuffer?.relatedTickets ? (
                                <PosSearchTicket
                                    isOnly={
                                        !(responseDataBuffer?.ticket &&
                                        responseDataBuffer?.relatedTickets
                                            ?.length
                                            ? true
                                            : !responseDataBuffer?.ticket &&
                                                responseDataBuffer
                                                    ?.relatedTickets?.length > 1
                                              ? true
                                              : false)
                                    }
                                    setShowTicketInfo={setShowTicketInfo}
                                    ticket={
                                        responseDataBuffer?.ticket
                                            ? responseDataBuffer?.ticket
                                            : responseDataBuffer
                                                  ?.relatedTickets?.[0]
                                    }
                                    relatedTickets={
                                        responseDataBuffer?.ticket
                                            ? responseDataBuffer?.relatedTickets
                                            : responseDataBuffer?.relatedTickets?.slice(
                                                  1,
                                              )
                                    }
                                    searched={true}
                                    clickedTicketPos={clickedTicketPos}
                                    handleClickedTicket={handleClickedTicket}
                                    handleCheckFunction={handleCheck}
                                    setClickedInstalmentPos={
                                        setClickedInstalmentPos
                                    }
                                    currency={currency}
                                    selectedSettlementsPos={
                                        selectedSettlementsPos
                                    }
                                />
                            ) : (
                                <></>
                            )}
                        </div>
                        <div
                            className={`${styles.main_settlements_container} v-flex-container`}
                        >
                            {responseDataBuffer?.settlements?.length ? (
                                <>
                                    <h4
                                        className={`${styles.ticket_type_label} flex-container`}
                                    >
                                        {t(`settlements`)}
                                    </h4>
                                    {responseDataBuffer?.settlements?.map(
                                        (settlement, idx) => (
                                            <PosSearchSettlement
                                                key={`${settlement?.caseNo}-${idx}`}
                                                isOnly={false}
                                                setShowTicketInfo={
                                                    setShowTicketInfo
                                                }
                                                ticket={settlement}
                                                searched={true}
                                                clickedTicketPos={
                                                    clickedTicketPos
                                                }
                                                handleClickedTicket={
                                                    handleClickedTicket
                                                }
                                                handleCheckFunction={
                                                    handleCheckSettlement
                                                }
                                                currency={currency}
                                                selectedSettlementsPos={
                                                    selectedSettlementsPos
                                                }
                                                setCurrenInstalmentPos={
                                                    setCurrenInstalmentPos
                                                }
                                                clickedInstalmentPos={
                                                    clickedInstalmentPos
                                                }
                                                handleClickedInstalment={
                                                    handleClickedInstalment
                                                }
                                                handleCheckInstalment={
                                                    handleCheckInstalment
                                                }
                                            />
                                        ),
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                    </>
                )}
            </section>
            <div className={`${styles.cart_button_container} flex-container`}>
                <ButtonPopup
                    body={t("add to cart")}
                    type={"button"}
                    onClickFuction={handleAddSelection}
                    setHoverFlag={setIsAddHoverPos}
                    disabled={
                        isProcessing ||
                        isProcessingPos ||
                        (!selectedTicketsPos.length &&
                            !selectedInstalmentsPos.length)
                    }
                    garyDisabled={
                        isProcessing ||
                        isProcessingPos ||
                        (!selectedTicketsPos.length &&
                            !selectedInstalmentsPos.length)
                    }
                    popup={
                        isProcessing || isProcessingPos
                            ? ""
                            : t("choose a ticket")
                    }
                />
            </div>
        </aside>
    );
};

export default PosTicketPanel;
